// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Core Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Main Pages
import Homepage from './pages/Homepage';
import AboutUs from './pages/AboutUs';
import ConnectWithUs from './pages/ConnectWithUs';
import Faq from './pages/Faq';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Ziyarat Related Pages
import HistoricalSites from './pages/HistoricalSites';
import ImportantEvents from './pages/ImportantEvents';
// Specific Shrine Pages
import AlAbbasShrine from './pages/shrines/AlAbbasShrine';
import AlMukhayamShrine from './pages/shrines/AlMukhayamShrine';
import ShrineOfImamHussain from './pages/shrines/ShrineOfImamHussain';
import ShrineOfTwoSonsMuslimIbnAqeel from './pages/shrines/ShrineOfTwoSonsMuslimIbnAqeel';
import ShrineOfImamAli from './pages/shrines/ShrineOfImamAli'; 

// Imam Mahdi (PBUH) Pages
import ImamMahdi from './pages/ImamMahdi'; // Parent page
import DescribedInQuranHadith from './pages/imamMahdi/DescribedInQuranHadith';
import HowToTalk from './pages/imamMahdi/HowToTalk';
import Return from './pages/imamMahdi/Return';
import Supporters from './pages/imamMahdi/Supporters';
import ImpactAppearance from './pages/imamMahdi/ImpactAppearance';
import Misconceptions from './pages/imamMahdi/Misconceptions';
import PracticesAllegiance from './pages/imamMahdi/PracticesAllegiance';
import ReflectionsStories from './pages/imamMahdi/ReflectionsStories';
import SignsReappearance from './pages/imamMahdi/SignsReappearance';
import UltimateReformer from './pages/imamMahdi/UltimateReformer';
import WhyOccultation from './pages/imamMahdi/WhyOccultation';

//events
import Ashura from "./pages/events/Ashura";
import Arbaeen from "./pages/events/Arbaeen";

// Logistics/Travel Pages
import Logistics from './pages/Logistics';
import Accommodations from './pages/Accommodations';
import SafetyTips from './pages/SafetyTips';
// Specific Hotel Pages
import KarbalaRayhaan from './pages/hotels/KarbalaRayhaan';
import MemoryIslamMuseum from './pages/hotels/MemoryIslamMuseum';
import TheBarol from './pages/hotels/TheBarol';
import CoralKarbala from './pages/hotels/CoralKarbala';

//Guides
import Guides from "./pages/guides/Guides";
import GuidePost from "./pages/guides/GuidePost";


function App() {
  return (
    <BrowserRouter>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            {/* Core Pages */}
            <Route path="/" element={<Homepage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/connect-with-us" element={<ConnectWithUs />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />

            {/* Ziyarat Routes */}
            <Route path="/shrines" element={<HistoricalSites />} /> 
            <Route path="/historical-sites" element={<HistoricalSites />} />
            <Route path="/important-events" element={<ImportantEvents />} />
            {/* Specific Shrine Routes */}
            <Route path="/shrines/shrine-of-imam-hussain" element={<ShrineOfImamHussain />} />
            <Route path="/shrines/al-abbas-shrine" element={<AlAbbasShrine />} />
            <Route path="/shrines/al-mukhayam-shrine" element={<AlMukhayamShrine />} />
            <Route path="/shrines/shrine-of-two-sons-muslim-ibn-aqeel" element={<ShrineOfTwoSonsMuslimIbnAqeel />} />
            <Route path="/shrines/shrine-of-imam-ali" element={<ShrineOfImamAli />} />

            {/* Imam Mahdi (PBUH) Routes */}
            <Route path="/imam-mahdi" element={<ImamMahdi />} /> {/* Parent page */}
            <Route path="/imam-mahdi/ultimate-reformer" element={<UltimateReformer />} />
            <Route path="/imam-mahdi/why-occultation" element={<WhyOccultation />} />
            <Route path="/imam-mahdi/described-in-quran-hadith" element={<DescribedInQuranHadith />} />
            <Route path="/imam-mahdi/return" element={<Return />} />
            <Route path="/imam-mahdi/supporters" element={<Supporters />} />
            <Route path="/imam-mahdi/impact-appearance" element={<ImpactAppearance />} />
            <Route path="/imam-mahdi/misconceptions" element={<Misconceptions />} />
            <Route path="/imam-mahdi/practices-allegiance" element={<PracticesAllegiance />} />
            <Route path="/imam-mahdi/reflections-stories" element={<ReflectionsStories />} />
            <Route path="/imam-mahdi/signs-reappearance" element={<SignsReappearance />} />
            <Route path="/imam-mahdi/how-to-talk" element={<HowToTalk />} />

            {/* events Routes */}
            <Route path="/events/ashura" element={<Ashura />} />
            <Route path="/events/arbaeen" element={<Arbaeen />} />

            {/* Logistics/Travel Routes */}
            <Route path="/logistics" element={<Logistics />} />
            <Route path="/accommodations" element={<Accommodations />} />
            <Route path="/safety-tips" element={<SafetyTips />} />
            {/* Specific Hotel Routes */}
            <Route path="/hotels/karbala-rayhaan" element={<KarbalaRayhaan />} />
            <Route path="/hotels/memory-islam-museum" element={<MemoryIslamMuseum />} />
            <Route path="/hotels/the-barol" element={<TheBarol />} />
            <Route path="/hotels/coral-karbala" element={<CoralKarbala />} />

            {/* Guides Routes */}
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/:slug" element={<GuidePost />} />


            {/* Catch-all route for 404 */}
            <Route path="*" element={
              <div className="page-container">
                <h1 className="page-title">404 - Page Not Found</h1>
                <p>Sorry, the page you are looking for does not exist.</p>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
